/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
require('plugins');
require('lib/ujs');

window.Routes = require('config/routes.js.erb');
window.I18n = require('i18n-js');
require('config/i18n_translation');
require('config/airbrake');

window.SMMustHeaderView = require('components/header/SMMustHeaderView');
window.SMHeaderNavi = require('components/header/SMHeaderNavi');
window.SMMobileDrawer = require('components/header/SMMobileDrawer');
window.SMMobileHeaderSearch = require('components/header/SMMobileHeaderSearch');
window.SMHeaderSearch = require('components/header/SMHeaderSearch');
window.SMHomeView = require('components/home/SMHomeView');
window.SMSearchListView = require('components/search/SMSearchListView');
window.SMUserReputationListView = require('components/users/SMUserReputationListView');
window.SMRoomView = require('components/rooms/SMRoomView');
window.SMRoomReputationListView = require('components/rooms/SMRoomReputationListView');
window.SMSpaceView = require('components/spaces/SMSpaceView');
window.SMSpaceReputationListView = require('components/spaces/SMSpaceReputationListView');
window.SMOwnerView = require('components/owners/SMOwnerView');
window.SMOwnerReputationListView = require('components/owners/SMOwnerReputationListView');
window.SMConciergeFormView = require('components/concierge/SMConciergeFormView');
window.SMConciergeDetailFormView = require('components/concierge/SMConciergeDetailFormView');
window.SMFeatureView = require('components/features/SMFeatureView');
window.SMFeatureListView = require('components/features/SMFeatureListView');
window.SMAboutHeaderView = require('components/about/SMAboutHeaderView');
window.SMReferralView = require('components/referrals/SMReferralView');
window.SMCategoryHomeView = require('components/categories/SMCategoryHomeView');
window.SMCategoryReputationListView = require('components/categories/SMCategoryReputationListView');
window.SMCategoryListView = require('components/categories/SMCategoryListView');
window.SMCategoryFeatureListView = require('components/categories/SMCategoryFeatureListView');
window.SMPromotionView = require('components/promotions/SMPromotionView');
window.SMPromotionListView = require('components/promotions/SMPromotionListView');
window.SMItineraryView = require('components/itineraries/SMItineraryView');
window.SMRankingListView = require('components/ranking/SMRankingListView');
window.SMReservationRequestSentView = require('components/reservations/SMReservationRequestSentView');
window.SMOUSignUpFormView = require('components/sessions/SMOUSignUpFormView');
window.SMSignUpView = require('components/sessions/SMSignUpView');
window.SMOSignUpFormView = require('components/sessions/SMOSignUpFormView');
window.SMLoginView = require('components/sessions/SMLoginView');
window.SMMailConfirmationView = require('components/sessions/SMMailConfirmationView');
window.SMReservationView = require('components/reservations/SMReservationView');
window.SMReservationRequestSentView = require('components/reservations/SMReservationRequestSentView');
window.SMRoomInquirySentView = require('components/rooms/SMRoomInquirySentView');
window.SMStayHomeView = require('components/home/SMStayHomeView');
window.SMAppReservationView = require('components/reservations/SMAppReservationView');
window.SMReservationInvitationView = require('components/reservations/SMReservationInvitationView');
window.SMHomeStaffFeaturesView = require('components/home/SMHomeStaffFeaturesView');
window.SMReservationInvitationRepliedView = require('components/reservations/SMReservationInvitationRepliedView');
window.SMAprilfoolView = require('components/others/SMAprilfoolView');
window.SMHostEntryView = require('components/pages/SMHostEntryView');
window.SMEnterpriseView = require('components/enterprises/SMEnterpriseView');
window.SMEnterpriseSentView = require('components/enterprises/SMEnterpriseSentView');
window.SMOptionalServiceView = require('components/optional_services/SMOptionalServiceView');
window.SMOptionalServiceSentView = require('components/optional_services/SMOptionalServiceSentView');



// WEBPACK FOOTER //
// ./app/javascript/packs/application.js